import { render, staticRenderFns } from "./TenantAuth.vue?vue&type=template&id=0a269e6c&scoped=true&"
import script from "./TenantAuth.vue?vue&type=script&lang=js&"
export * from "./TenantAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a269e6c",
  null
  
)

export default component.exports